import { IAddWordingsContext } from './addWordingsContext';

export enum AddWordingsActionsTypes {
	SET_ID_CATEGORY = 'SET_ID_CATEGORY',
	CHANGE_KEY = 'CHANGE_KEY',
	SET_FETCHED_LANGUAGES = 'SET_FETCHED_LANGUAGES',
	CHANGE_TRANSLATIONS = 'CHANGE_TRANSLATIONS',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	RESET_FIELDS = 'RESET_FIELDS',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
}

interface ISetCategory {
	type: AddWordingsActionsTypes.SET_ID_CATEGORY;
	payload: {
		IDSelectedCategory: IAddWordingsContext['IDSelectedCategory'];
	};
}

interface IChangeKey {
	type: AddWordingsActionsTypes.CHANGE_KEY;
	payload: {
		key: IAddWordingsContext['key'];
	};
}

interface ISetFetchedLanguages {
	type: AddWordingsActionsTypes.SET_FETCHED_LANGUAGES;
	payload: {
		fetchedLanguages: IAddWordingsContext['fetchedLanguages'];
	};
}

interface IChangeTranslations {
	type: AddWordingsActionsTypes.CHANGE_TRANSLATIONS;
	payload: {
		translations: IAddWordingsContext['translations'];
	};
}

interface ISetDataForSubmit {
	type: AddWordingsActionsTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: IAddWordingsContext['dataForSubmit'];
	};
}

interface IResetFields {
	type: AddWordingsActionsTypes.RESET_FIELDS;
}

interface IChangeTypeOfModalWindow {
	type: AddWordingsActionsTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IAddWordingsContext['typeOfModalWindow'];
	};
}

export type TAddWordingsAction =
	| ISetCategory
	| IChangeKey
	| ISetFetchedLanguages
	| IChangeTranslations
	| ISetDataForSubmit
	| IResetFields
	| IChangeTypeOfModalWindow;
